export default [
    {
        "id": "news-1",
        "plugin": "blog",
        "pluginId": 12,
        "config": `{"GET_pageId":"pageId"}`,
        "html": require('./news/news-1/html').default,
        "scss": require('./news/news-1/scss').default,
        "scssTablet": require('./news/news-1/scssTablet').default,
        "scssMobile": require('./news/news-1/scssMobile').default,
        "css": require('./news/news-1/css').default,
        "cssTablet": require('./news/news-1/cssTablet').default,
        "cssMobile": require('./news/news-1/cssMobile').default,
        "js": require('./news/news-1/js').default,
        "minJs": require('./news/news-1/minJs').default,
        "name": "blog",
        "svgContent": require('./news/news-1/svgContent').default,
        "svgViewBox": "0 0 1440 464",
        "svgContentMobile": require('./news/news-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 436",
        "folder": "news"
    }
]
